import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.number.is-integer.js";
import "core-js/modules/es6.number.constructor.js";
import cloneDeep from 'lodash/cloneDeep';
import { FIB } from '@/config/constants';
var MENU_INSIGHT_MODE = FIB.MENU_INSIGHT_MODE; // TODO: WHY THESE 3 FUNCTIONS ALL MAP TO BASIC AND DO NOTHING DIFFERENT

/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products products currently available
 *
 * @returns {Array} array of 'dishes' for type mode
 *
 */

function getTypeDishes(question, products) {
  return mapProductsToDishes(question, products);
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products products currently available
 *
 * @returns {Array} array of 'dishes' for family group mode
 *
 */


function getFamilyGroupDishes(question, products) {
  return mapProductsToDishes(question, products);
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products products currently available
 *
 * @returns {Array} array of 'dishes' for major group mode
 *
 */


function getMajorGroupDishes(question, products) {
  return mapProductsToDishes(question, products);
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products products currently available
 *
 * @returns {Array} array of 'dishes' based on available products
 *
 */


function mapProductsToDishes(question, products) {
  // loop through products and create new 'inline' dish for each one
  var dishes = products.map(function (p) {
    return {
      id: p.ref,
      ref: p.ref,
      title: p.name,
      subQuestions: getSubquestions(question, p),
      meta: {
        product: p
      }
    };
  });
  return dishes;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Array} products array of available products
 *
 * @returns {Array} array of subcategory options for the product
 *
 */


function getSubquestions(question, product) {
  var subQuestions = [];
  var ratings = cloneDeep(question.ratings); // create subQuestion for each rating

  for (var i in ratings) {
    var rating = cloneDeep(ratings[i]);
    var reasonSections = cloneDeep(rating.reasonSections);

    for (var j in reasonSections) {
      var section = cloneDeep(reasonSections[j]);
      var sectionOptions = section.reasons.map(function (r) {
        return {
          id: r.id,
          label: r.text,
          val: r.id
        };
      });
      subQuestions.push({
        id: 'question' + question.id + 'product' + product.ref + 'rating' + i + 'reasonSection' + j,
        type: 'fib-select-option',
        showIf: section.showIf,
        required: false,
        // TODO - find out what sets this
        label: section.title,
        meta: {
          rating: rating,
          section: section
        },
        props: {
          center: true,
          multiple: true,
          options: sectionOptions
        }
      });
    }
  } // add comments box if applicable


  subQuestions.push({
    id: 'question' + question.id + 'product' + product.ref + 'comment',
    type: 'fib-comments',
    required: true,
    // TODO : find out if this needs setting and how to check if it is
    label: '',
    props: {
      rows: 6
    }
  });
  return subQuestions;
}
/**
 *
 * @param {Object} question menu insight question
 * @param {Number} mode menu insight question mode
 * @param {Array} products products currently available
 *
 * @returns {Array} array of dishes
 *
 */


function getFlatDishes(question, mode) {
  var products = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  // If not given integer for mode, throw error
  if (!Number.isInteger(mode)) {
    throw 'getFlatDishes only accepts integer for mode';
  } // If not given a question, throw error


  if (!question) {
    throw 'getFlatDishes requires a question';
  } // If not given arrays for relevant params, throw error


  if (!Array.isArray(products)) {
    throw 'getFlatDishes requires array of products';
  } // detect mode and handle if mode supported


  if (mode === MENU_INSIGHT_MODE.TYPE) {
    return getTypeDishes(question, products);
  } else if (mode === MENU_INSIGHT_MODE.FAMILY_GROUP) {
    return getFamilyGroupDishes(question, products);
  } else if (mode === MENU_INSIGHT_MODE.MAJOR_GROUP) {
    return getMajorGroupDishes(question, products);
  } else {
    return [];
  }
}

export default getFlatDishes;